module.exports = __webpack_public_path__ + "static/media/neha.21f41f2f.png";